import { createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from 'libraries/axios'
import {RootState} from "../../types";

export const getCities = createAsyncThunk('get/cities', async (body:any, {getState, rejectWithValue }) => {

  try {
      const searchQuery = body.search.length > 0 ? `&search=${encodeURIComponent(body.search)}` : "";
      const { data } = await axiosInstance.get(`/v2/novaposhta/cities?page=${body.page}${searchQuery}`)

      const prevCities = (getState() as RootState).nova.cities.data || []
      const newCities = body.page > 1 ? [...prevCities, ...data.data] : data.data

      return newCities
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})


export const getWarehouses = createAsyncThunk(
    'get/warehouses',
    async (body:any, {getState, rejectWithValue }) => {
      try {
          const searchQuery = body.search.length > 0 ? `&search=${encodeURIComponent(body.search)}` : "";

          const { data } = await axiosInstance.get(
              `/v2/novaposhta/warehouses?page=${body.page}&city_ref=${body.ref}${searchQuery}`
          );

        const prevWarehouses = (getState() as RootState).nova.warehouses.data || []
        const newWarehouses = body.page > 1 ? [...prevWarehouses, ...data.data] : data.data

        return newWarehouses
      } catch (error: any) {
        return rejectWithValue(error.response.data)
      }
    }
)

